<script setup>

</script>

<template>
  <h1> Select Device First By Links Above </h1>
</template>

<style scoped>

</style>